var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8303 -0.00244141C5.78454 -0.00244141 0.866699 4.91995 0.866699 10.9673V26.634C0.866699 32.6797 5.78909 37.5976 11.8364 37.5976H27.5031C33.5489 37.5976 38.4667 32.6752 38.4667 26.6278V10.9612C38.4667 4.9154 33.5443 -0.00244141 27.497 -0.00244141H11.8303ZM30.6334 6.26423C31.4982 6.26423 32.2 6.96609 32.2 7.83089C32.2 8.69569 31.4982 9.39756 30.6334 9.39756C29.7686 9.39756 29.0667 8.69569 29.0667 7.83089C29.0667 6.96609 29.7686 6.26423 30.6334 6.26423ZM19.6667 9.39756C24.8508 9.39756 29.0667 13.6135 29.0667 18.7976C29.0667 23.9817 24.8508 28.1976 19.6667 28.1976C14.4826 28.1976 10.2667 23.9817 10.2667 18.7976C10.2667 13.6135 14.4826 9.39756 19.6667 9.39756ZM19.6667 12.5309C18.0047 12.5309 16.4107 13.1911 15.2355 14.3664C14.0603 15.5416 13.4 17.1355 13.4 18.7976C13.4 20.4596 14.0603 22.0535 15.2355 23.2288C16.4107 24.404 18.0047 25.0642 19.6667 25.0642C21.3287 25.0642 22.9227 24.404 24.0979 23.2288C25.2731 22.0535 25.9334 20.4596 25.9334 18.7976C25.9334 17.1355 25.2731 15.5416 24.0979 14.3664C22.9227 13.1911 21.3287 12.5309 19.6667 12.5309Z",
    fill: "#0079BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.141717b4755a8497877b05736aaef53f.svg";
export { ForwardRef as ReactComponent };